import Image1 from "../../assets/testimonial/testimonial1.jpeg";
import Image2 from "../../assets/testimonial/testimonial2.png";
import Image3 from "../../assets/testimonial/testimonial3.jpeg";

export const Data = [
  {
    id: 1,
    image: Image3,
    title: "Nicolas Franco",
    status: "Chartered Accountant - ADLIR Conseils",
    description:
      "A really good job, all aspects of the project were followed step by step and with good results.",
  },
  {
    id: 2,
    image: Image2,
    title: "Rami Khedair",
    status: "Student",
    description:
      "A really good job, all aspects of the project were followed step by step and with good results.",
  }
];
